/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../_helpers'
import { unitProductsService } from '../../_services/unitProducts.service'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
// import Step2 from './Step2'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      key: 'info',
      id: this.props.id,
      data: {
        unitId: '',
        ids: ''
      }
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      this.setState({ loading: true })

      await unitProductsService
        .getById(id)
        .then(res => {
          let data = res.data
          // console.log(data);
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          console.log(error)

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });

    values.ids = values.ids.filter(el => el !== '*')

    console.log(JSON.stringify(values))

    unitProductsService
      .add(JSON.stringify(values))
      .then(res => {
        console.log(res.data)

        this.setState({ loading: false })
        toastr.success('ورود کالاها با موفقیت انجام شد')

        setSubmitting(false)

        this.props.onClose()
      })
      .catch(error => {
        console.log(error)
        setSubmitting(false)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  validateForm = errors => {
    // if (Object.keys(errors).length > 0) {
    //   // // console.log(errors)
    //   let obj = errors
    //   let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
    //     driverDocuments,
    //     user
    //   } = obj;
    //   if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
    //     this.setState({ key: "info" })
    //   } else if (driverDocuments) {
    //     this.setState({ key: "images" })
    //   }
    // }
  }

  render() {
    const { data } = this.state
    const ValidationSchema = Yup.object().shape({
      unitId: Yup.string()
        .trim()
        .required('نام انبار'),
      ids: Yup.array()
        .min(1, 'حداقل یک محصول')
        .required('محصول')
    })
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  <button
                    type="submit"
                    className={
                      'icon button submit-btn ' +
                      (isSubmitting ? 'isSubmitting' : '')
                    }
                    disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        this.validateForm(errors)
                      })
                    }>
                    {isSubmitting ? (
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                    ) : (
                      <AiOutlineSave size="22px" />
                    )}
                    ذخیره
                  </button>
                  <Tabs
                    transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}>
                    <Tab
                      eventKey="info"
                      title="انتخاب و افزودن کالا ها به انبار">
                      <Step1 {...props} />
                    </Tab>
                  </Tabs>
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default Form
